import { Heading } from '@cinch-labs/design-system'
import styles from './nearby-locations.module.css'
import {
  Site,
  SiteWithDistance,
  SiteWithDistanceResponse,
} from '@cinch-labs/sites-sdk'
import { LocationCardCarousel } from './components/location-card-carousel/location-card-carousel'

interface NearbyLocationsProps {
  title: string
  cardButtonText: string
  site?: Site
  nearestSitesResponse?: SiteWithDistanceResponse[]
}

export const NearbyLocations: React.FC<NearbyLocationsProps> = ({
  title,
  cardButtonText,
  site,
  nearestSitesResponse,
}) => {
  if (nearestSitesResponse === undefined) return null

  const nearestSites: SiteWithDistance[] = nearestSitesResponse.map(
    (siteWithDistance) => ({
      site: new Site(siteWithDistance.site),
      distance: siteWithDistance.distance,
    }),
  )

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <Heading element="h2" className={styles.title}>
          {title}
        </Heading>
        <LocationCardCarousel
          sites={nearestSites}
          pageSiteOrgUnit={site?.getFeatureAttribute('organisationalUnit')}
          buttonText={cardButtonText}
        />
      </div>
    </section>
  )
}
